import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { SessionProvider } from './app/session';
import { ToastProvider } from './app/toast';
import { initTelegram } from './lib/telegram';
import './styles/app.css';

initTelegram();

const root = document.getElementById('root');
if (!root) throw new Error('Нет корневого элемента');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <SessionProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </SessionProvider>
    </BrowserRouter>
  </StrictMode>,
);
